module.exports = __webpack_public_path__ + "static/img/ls10.c40a288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/ls10.png
// module id = nd8j
// module chunks = 12